import { render } from "./Requisites.vue?vue&type=template&id=ef2ea286&scoped=true&ts=true"
import script from "./Requisites.vue?vue&type=script&lang=ts"
export * from "./Requisites.vue?vue&type=script&lang=ts"

import "./Requisites.vue?vue&type=style&index=0&id=ef2ea286&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2ea286"]])

export default __exports__